import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { Config } from "../../Config";
import Skeleton from "react-loading-skeleton";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./BrandSlider.scss";

const SampleNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        background: "transparent",
        right: "-2px",
        top: "30%",
        transform: "translateY(-30%)",
        width: "30px",
        height: "30px",
        zIndex: "2",
      }}
      onClick={onClick}
    />
  );
};

const SamplePrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        background: "transparent",
        color: "#000",
        left: "-2px",
        top: "30%",
        transform: "translateY(-30%)",
        width: "30px",
        height: "30px",
        zIndex: "2",
      }}
      onClick={onClick}
    />
  );
};

const BrandSlider = (props) => {
  const [skeletonCount, setSkeletonCount] = useState(0);
  useEffect(() => {
    let width = window.screen.width;
    if (width <= 1100) {
      if (width >= 992 && width <= 1100) {
        setSkeletonCount(4);
      } else if (width <= 992 && width >= 486) {
        setSkeletonCount(3);
      } else if (width <= 486 && width >= 400) {
        setSkeletonCount(2);
      } else {
        setSkeletonCount(1);
      }
    } else {
      setSkeletonCount(5);
    }
  }, []);
  const settings = {
    dots: props.dots,
    infinite: props.infinite,
    // speed: 2000,
    slidesToShow: props.slideCount,
    slidesToScroll: props.sldeToScroll,
    autoplay: props.autoplay,
    autoplaySpeed: props.slideSpeed,
    pauseOnHover: true,
    swipeToSlide: props.swipeToSlide,
    variableWidth: true,
    // adaptiveHeight: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div
      className="brandSliderWrapper"
      style={{ width: props.width, height: props.height, position: "relative", overflow: "hidden" }}
    >
      <Slider {...settings}>
        {props.sliderData.map((item, index) => {
          return (
            <div className="sliderImageFigure" key={index} sd={index}>
              <a href="#" draggable="false">
                <img src={item.image} alt={item.name} className="sliderImage" />
              </a>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default React.memo(BrandSlider);
